import { rentalManagerLoginOptionsForUser } from '@zg-rentals/login-zillow';
import { zillowLoginUrl } from '@zg-rentals/login-zillow/server';

interface SignInPageInterface {
  pathname: string;
  search: string;
  baseURL?: string;
  isInitialMultiFactorAuthenticationRequired?: boolean;
}

export const signInPageLandlord = ({
  pathname,
  search = '',
  baseURL,
  isInitialMultiFactorAuthenticationRequired,
}: SignInPageInterface) => {
  const redirectUri = pathname + (search ? `?${search}` : '');
  return zillowLoginUrl({
    baseURL: baseURL || process.env.NEXT_PUBLIC_AUTH_BASE_URL || '/',
    entryPoint: 'rent-payment-web',
    redirectUri,
    ...rentalManagerLoginOptionsForUser({ isInitialMultiFactorAuthenticationRequired }),
  });
};

export default {
  homePage: '/',
  onboarding: {
    checklistPage: '/onboarding/checklist',
    emptyLeasePage: '/onboarding/empty-lease',
    leaseSelectorPage: '/onboarding/lease-selector',
    areYouSurePage: '/onboarding/are-you-sure',
    ineligibleLeaseSelected: '/onboarding/ineligible-lease-selected',
    unsignedLeaseWarning: '/onboarding/unsigned-lease-warning',
    rentAmountPage: '/onboarding/rent-amount',
    differentValueThanLeaseWarningPage: '/onboarding/different-value-than-lease-warning',
    dueDatePage: '/onboarding/due-date',
    termLengthPage: '/onboarding/term-length',
    differentTermThanLeaseWarningPage: '/onboarding/different-term-than-lease-warning',
    accountInfoPage: '/onboarding/account-info',
    moveInCostsPage: '/onboarding/move-in-costs/',
    inviteTenantPage: '/onboarding/invite-tenant',
    taxVerificationPage: '/onboarding/tax-verification',
    phoneVerificationPage: '/onboarding/phone-verification',
    confirmationPage: '/onboarding/confirmation',
    postConfirmationPage: '/onboarding/success',
    stateDisclosures: '/onboarding/stateDisclosures',
    signCoverageRequest: '/onboarding/signCoverageRequest',
    coverageRequestSubmitted: '/onboarding/coverageRequestSubmitted',
    knowledgeBasedAuthenticationPage: '/onboarding/knowledge-based-authentication',
    exitPaymentSetup: '/onboarding/exit-payment-setup',
  },
  dashboard: {
    editRentAmountPage: '/edit/rent-amount',
    editRentAmountSimplePage: '/edit/rent-amount-simple',
    editDueDatePage: '/edit/due-date',
    editTermLengthPage: '/edit/term-length',
    editPaymentLengthPage: '/edit/payment-length',
    editAccountInfoPage: '/edit/account-info',
    editTenantInfoPage: '/edit/tenant-info',
    editStripeContactInfo: '/edit/contact-information',
    taxVerificationPage: '/edit/tax-verification',
    phoneVerificationPage: '/edit/phone-verification',
    stopPaymentsFeedbackPage: '/feedback/stop-payments',
    stripeVerificationPage: '/stripe-verification',
    createOneTimePaymentRequestPage: '/one-time-payment',
    cancelMoveInCostsRequest: '/cancel/move-in-costs',
    createMoveInCostsPage: '/create/move-in-costs',
    confirmMoveInCostsPage: '/confirm/move-in-costs',
    knowledgeBasedAuthenticationPage: '/knowledge-based-authentication',
    setupNewTermPage: '/setup-new-term',
    postConfirmationPage: '/setup-new-term/success',
    stateDisclosusres: '/state-disclosures',
    signCoverageRequest: '/sign-coverage-request',
    coverageRequestSubmitted: '/coverage-request-submitted',
    howToSetupPaymentPlan: '/how-to-setup-payment-plan',
    handleMissedRent: '/how-to-handle-missed-rent',
    PaymentPlanInstallmentRequests: '/payment-plan-installment-requests',
    emptyLeasePage: '/empty-lease',
    leaseSelectorPage: '/lease-selector',
    areYouSurePage: '/are-you-sure',
    ineligibleLeaseSelected: '/ineligible-lease-selected',
    unsignedLeaseWarning: '/unsigned-lease-warning',
    differentValueThanLeaseWarningPage: '/different-value-than-lease-warning',
    differentTermThanLeaseWarningPage: '/different-term-than-lease-warning',
    inviteTenantPage: '/invite-tenant',
    dueDatePage: '/due-date',
    termLengthPage: '/term-length',
    rentAmountPage: '/rent-amount',
  },
  auth: {
    stopImpersonatingPage: '/myzillow/Profile,$PageWrapper.$DirectLink.sdirect',
  },
};
